import cx from "classnames";
import type { FC, ReactElement, ReactNode } from "react";

import { baseStyles, disabledStyles, hoverStyles, iconStyles } from "../ToolbarItem/css";

import { CaretDownIcon } from "@moment/icons";

import { DropdownMenu } from "../DropdownMenu";
import { Hotkeys } from "../Hotkeys";

export type ToolbarItemComplexProps = {
	label: string;
	isActive?: boolean;
	isDisabled?: boolean;
	items: {
		onSelect?: () => void;
		label: string;
		hotkey?: string;
		icon?: ReactElement;
	}[];
	children?: ReactNode;
} & React.HTMLAttributes<HTMLButtonElement>;

export const ToolbarItemComplex: FC<ToolbarItemComplexProps> = ({
	label,
	isActive = false,
	isDisabled = false,
	children,
	...props
}) => {
	const items = props.items.map((item, i) => {
		return (
			<DropdownMenu.Item key={`toolbar-item-${i}`} onSelect={item.onSelect}>
				<div className="flex w-full flex-row items-center">
					<div className="mr-2">{item.icon}</div>
					<div className="mr-6">{item.label}</div>
					{item.hotkey && (
						<div className="ml-auto">
							<Hotkeys hotkey={item.hotkey} type="toggleable" />
						</div>
					)}
				</div>
			</DropdownMenu.Item>
		);
	});

	const b = (
		<button
			aria-label={label}
			className={cx(
				"px-2",
				baseStyles(isActive),
				hoverStyles(isActive),
				iconStyles(isActive),
				disabledStyles(isActive, isDisabled)
			)}
			disabled={isDisabled}
			{...props}
		>
			{children}
			<CaretDownIcon size={12} className="ml-1" />
		</button>
	);

	if (isDisabled) {
		return b;
	}

	return (
		<DropdownMenu.Root>
			<DropdownMenu.Trigger asChild>
				<button
					aria-label={label}
					className={cx(
						"px-2",
						baseStyles(isActive),
						hoverStyles(isActive),
						iconStyles(isActive),
						disabledStyles(isActive, isDisabled)
					)}
					disabled={isDisabled}
					{...props}
				>
					{children}
					<CaretDownIcon size={12} className="ml-1" />
				</button>
			</DropdownMenu.Trigger>
			{/* <DropdownMenu.Portal> */}
			<DropdownMenu.Content>
				{items}
				{items.length === 0 ? (
					<div className="px-4 italic text-secondary">No items</div>
				) : (
					<></>
				)}
			</DropdownMenu.Content>
			{/* </DropdownMenu.Portal> */}
		</DropdownMenu.Root>
	);
};
